import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { Currency } from "src/app/domain/models/currency"
import { Routes } from "src/app/infrastructure/routes"
import { CurrencyGateway } from "../gateway/CurrencyGateway"

@Injectable({providedIn: 'root'})
export class CurrencyService extends CurrencyGateway {

  constructor(private _http: HttpClient) {
    super()
  }

  getAll(): Observable<Currency[]> {
    return this._http.get<Currency[]>(Routes.currencyApi + '/GetAll')
  }

}
